import React from 'react';
import PropTypes from 'prop-types';
import { Router } from '../../../src/i18n';
import { MEDIA_TABS, TP } from '../../../constants/consts';
import StepperButtonsBlock from '../../../components/Stepper/StepperButtonsBlock';
import route from '../../../constants/routes';
import { getRouteWithCountryAndSlug, getRouteWithSlug } from '../../../utils/common';
import { PRODUCTIONS_TYPES } from '../../Company/constants';
import { EDITING_PRODUCTION_ENTITY_TYPES } from '../constants';
import { EditLayout } from '../../../components/EditComponents/EditLayout';
import ImagesSection from '../components/ImagesSection';
import VideoSection from '../components/VideoSection';
import SynopsisSection from '../components/SynopsisSection';
import { getQueryFuncForEditStep } from '../utils';
import { getFestivalRoute } from '../../Festival/utils';
import { editFestivalTabValues } from '../../Festival/edit';
import { artistEditTabValues } from '../../Artist/Edit';
import { companyEditTabValues } from '../../Company/edit';

const EditProductionMedia = ({ production, entity, step, type }) => {
  const queryStepFunc = getQueryFuncForEditStep(type);

  const nextStepAction = () => {
    const productionType = production?.published_at ? PRODUCTIONS_TYPES.published : PRODUCTIONS_TYPES.unpublished;
    switch (type) {
      case EDITING_PRODUCTION_ENTITY_TYPES.COMPANY:
        Router.push({
          pathname: `${getRouteWithCountryAndSlug(route.COMPANIES, entity)}/edit`,
          query: {
            tab: companyEditTabValues.seasons,
            'productions-type': productionType,
          },
        });
        break;
      case EDITING_PRODUCTION_ENTITY_TYPES.ARTIST:
        Router.push({
          pathname: `${getRouteWithSlug(route.ARTISTS, entity)}/edit`,
          query: { tab: artistEditTabValues.schedule, 'productions-type': productionType },
        });
        break;
      case EDITING_PRODUCTION_ENTITY_TYPES.FESTIVAL:
        Router.push({
          pathname: `${getFestivalRoute(entity)}/edit`,
          query: {
            tab: editFestivalTabValues.seasons,
            'productions-type': productionType,
          },
        });
        break;
      default:
        break;
    }
  };

  const backStepAction = () => {
    const { pathname, query } = queryStepFunc({ entity, production, step: step - 1 });
    Router.push({ pathname, query });
  };

  const tabs = {
    [MEDIA_TABS.SYNOPSIS]: {
      value: MEDIA_TABS.SYNOPSIS,
      name: `${TP}.FN_SYNOPSIS`,
      form: <SynopsisSection production={production} />,
    },
    [MEDIA_TABS.IMAGES]: {
      value: MEDIA_TABS.IMAGES,
      name: `${TP}.m_IMAGES`,
      title: `${TP}.m_IMAGES`,
      subtitle: `${TP}.m_IMAGES`,
      form: <ImagesSection production={production} />,
    },
    [MEDIA_TABS.VIDEO]: {
      value: MEDIA_TABS.VIDEO,
      name: `${TP}.m_VIDEO`,
      title: `${TP}.m_VIDEO`,
      subtitle: `${TP}.m_VIDEO`,
      form: <VideoSection production={production} />,
    },
  };

  const [selectedTab, selectTab] = React.useState(tabs[MEDIA_TABS.SYNOPSIS]);

  const goToTab = tabName => {
    selectTab(tabs[tabName]);
  };

  return (
    <>
      <EditLayout tabs={tabs} selectedTab={selectedTab} goToTab={goToTab} />
      <div style={{ margin: 40 }} />
      <StepperButtonsBlock
        activeStepNumber={3}
        activeStep={{ backStepAction, nextStepAction, info: null }}
        isLastStep
      />
    </>
  );
};

EditProductionMedia.propTypes = {
  production: PropTypes.object,
  entity: PropTypes.object,
  type: PropTypes.oneOf(Object.values(EDITING_PRODUCTION_ENTITY_TYPES)).isRequired,
};

export default EditProductionMedia;
